import * as React from 'react';
import { IslandFooter } from './IslandFooter';
import { IslandBody } from './IslandBody';
import { IslandContainer } from './IslandContainer';
import { IslandHeader, IslandHeaderProps } from './IslandHeader';
import { Spacing } from './IslandSectionContainer';
import { Justify } from '@ardoq/layout';

export type IslandProps = {
  children?: React.ReactNode;
  footerContent?: React.ReactNode;
  footerJustify?: Justify;
  bodySpacing?: Spacing;
  header?: React.ReactNode;
  isSelected?: boolean;
  isSelectable?: boolean;
  onClick?: VoidFunction;
  maxWidth?: string;
  minWidth?: string;
  minHeight?: string;
  bodyMinHeight?: string;
  withBorder?: boolean;
  fullHeight?: boolean;
  flex?: number;
  isScrollable?: boolean;
  preventScroll?: boolean;
  dataTourId?: string;
} & IslandHeaderProps;

export const Island = ({
  children,
  bodySpacing,
  preventScroll,
  isScrollable,
  footerContent,
  footerJustify,
  header,
  isSelected,
  isSelectable,
  onClick,
  maxWidth,
  minWidth,
  minHeight,
  bodyMinHeight,
  withBorder = true,
  fullHeight = false,
  flex,
  dataTourId,
  ...headerProps
}: IslandProps) => (
  <IslandContainer
    data-tour-id={dataTourId}
    $isSelectable={isSelectable}
    $isSelected={isSelected}
    onClick={onClick}
    $maxWidth={maxWidth}
    $minWidth={minWidth}
    $minHeight={minHeight}
    $preventScroll={preventScroll}
    $withBorder={withBorder}
    $fullHeight={fullHeight}
    flex={flex}
  >
    {header || <IslandHeader {...headerProps} />}
    {children && (
      <IslandBody
        $fullHeight={fullHeight}
        $minHeight={bodyMinHeight}
        flex={flex}
        $spacing={bodySpacing}
        $preventScroll={preventScroll}
        $isScrollable={isScrollable}
      >
        {children}
      </IslandBody>
    )}
    {footerContent && (
      <IslandFooter justify={footerJustify}>{footerContent}</IslandFooter>
    )}
  </IslandContainer>
);
